import { useStrings } from "@1js/localization-components";
import type { Prompt } from "@1js/pl-card-components";
import { isBizChatPrompt } from "@1js/pl-types";
import { useFlightContext } from "../useFlightContext";
import {
  ShareToastCopyLinkBody,
  ShareToastCopyLinkTitle,
  TryAgainLabel,
} from "./useShareToast.strings";
import { useToast } from "./useToast";

/**
 * Hook to show a toast when the user copies the prompt
 */
export const useShareToast = (...props: Parameters<typeof useToast>) => {
  const { notify } = useToast(...props);
  const strings = useStrings({
    TryAgainLabel,
    ShareToastCopyLinkTitle,
    ShareToastCopyLinkBody,
  });
  const { isFlightActive } = useFlightContext();

  const notifyShareCopyLinkSuccess = (prompt: Prompt) =>
    notify(
      "success",
      strings.ShareToastCopyLinkTitle(),
      isFlightActive("isPromptSharingEnabled") && isBizChatPrompt(prompt)
        ? strings.ShareToastCopyLinkBody()
        : undefined
    );

  const notifyShareCopyLinkFail = () =>
    notify("error", strings.TryAgainLabel());

  return { notifyShareCopyLinkSuccess, notifyShareCopyLinkFail };
};
